import React, { useState } from "react";

import Footer from "./footer";
import Loader from "react-loader-spinner";
import NavBar from "./navBar";
import SearchInput from "./search/SearchInput";
import axios from "axios";
import i18n from "../../i18n";
import styles from "./search/SearchInput.module.css";

function GPT() {
  const [userInput, setUserInput] = useState("");
  const [response, setResponse] = useState("");
  const [sources, setSources] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("");

  const handleInputChange = (e) => {
    setUserInput(e.target.value);
  };

  const handleSubmit = async () => {
    setLoading(true);
    const loadingMessages = [
      i18n.t("loadingMessage1"),
      i18n.t("loadingMessage2"),
      i18n.t("loadingMessage3"),
      i18n.t("loadingMessage4"),
      i18n.t("loadingMessage5"),
      i18n.t("loadingMessage6"),
      i18n.t("loadingMessage7"),
      i18n.t("loadingMessage8"),
      i18n.t("loadingMessage9"),
      i18n.t("loadingMessage10")
    ];
    const randomMessage = loadingMessages[Math.floor(Math.random() * loadingMessages.length)];
    setLoadingText(randomMessage);
    try {
      const result = await axios.post("https://gpt.digital-doctor-house.com/chatbot", {
        input_text: userInput,
      });

      if (result.response) {
        setResponse(result.response);
        const uniqueSources = removeDuplicateSources(result.sources || []);
        setSources(uniqueSources);
      } else {
        setResponse("Unexpected response format from the server.");
        setSources([]);
      }
    } catch (error) {
      console.log(error);
      alert("Error sending request:", error.toString());
      setResponse("Error getting response from chatbot.");
      setSources([]);
    }
    setLoading(false);
  };

  const removeDuplicateSources = (sourcesArray) => {
    const uniqueUrls = new Set();
    const uniqueSources = [];

    for (const source of sourcesArray) {
      const url = source.Url;
      if (!uniqueUrls.has(url)) {
        uniqueUrls.add(url);
        uniqueSources.push(source);
      }
    }

    return uniqueSources;
  };

  return (
    <React.Fragment>
      <NavBar />
      <div className="row justify-content-center no-gutters">
        <div className="col-12">
          <div className="s130">
            <form>
              <div className="inner-form searchResultSearchBar">
                <SearchInput
                  value={userInput}
                  onChange={handleInputChange}
                  placeholder={i18n.t("enterPrompt")}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault(); // Prevent newline
                      handleSubmit();     // Submit form
                    }
                  }}
                  multiline={true}
                />
                <div className={styles.buttonWrap}>
                  <button 
                    className={styles.button} 
                    type="button"
                    onClick={handleSubmit}
                  >
                    {i18n.t("search")}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="response-container">
        {loading ?
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Loader type="ThreeDots" color="#00BFFF" height={50} width={50} />
            <span style={{ color: '#00BFFF', fontSize: '16px' }}>{loadingText}</span>
          </div> :
          <div
            className="response-text"
            dangerouslySetInnerHTML={{ __html: response }}
          ></div>
        }
      </div>
      {sources.length == 0 || loading ? (
        <></>
      ) : (
        <>
          <div className="source-list">
            <h4>Sources and relevant information</h4>
            {sources.map((source, index) => (
              <>
                <br></br>
                <a
                  key={index}
                  className="response-source"
                  href={source.Url}
                  target="_blank"
                >
                  {source.Url}
                </a>
              </>
            ))}
          </div>
        </>
      )}

      <Footer />
    </React.Fragment>
  );
}

export default GPT;
